<template>
    <div class="py-20">
        <div class="block mx-auto max-w-lg w-full">
            <div class="flex justify-between flex-wrap items-center mb-2">
                <div>
                    <h1 class="font-special text-white font-normal uppercase text-3xl">Email Extravaganza</h1>
                </div>
                <div>
                    <a href="javascript:void(0)" class="text-white no-underline hover:underline" @click="logout">Logout</a>
                </div>
            </div>
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            logout() {
                this.$auth.logout({
                    makeRequest: true,
                    success() {
                        this.$router.push('/login')
                    },
                });
            }
        }
    }
</script>
